module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.campaign) ? _c('div', {
    staticClass: "col-lg-12"
  }, [_c('loader', {
    attrs: {
      "message": "Loading your campaign"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.campaign) ? _c('div', [_c('campaign-detail', {
    attrs: {
      "id": parseInt(_vm.campaign.id, 10),
      "campaign": _vm.campaign,
      "interactions": _vm.interactions,
      "loadingCampaignReport": _vm.loadingCampaignReport,
      "campaignReportData": _vm.campaignReportData,
      "icons": _vm.icons,
      "channelTypes": _vm.channelTypes,
      "replyMessage": _vm.replyMessage
    },
    on: {
      "onDownloadMessage": function($event) {
        return _vm.onDownloadMessage($event)
      },
      "onRandomSelector": function($event) {
        return _vm.onRandomSelector($event)
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('thread-dialog')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4c523f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/containers/campaign/CampaignDetailContainer.vue
// module id = 3382
// module chunks = 3